<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
            <v-card class="mb-2 background-2 round-card" ref="notificationssetting">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title> 
                <v-divider></v-divider>

                
                <v-subheader class="pl-4">Notifiche</v-subheader>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                            color="primary" 
                            hide-details
                            v-model="settings['notify_owner_at_trouble_close']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Chiusura Ticket</v-list-item-title>
                            <v-list-item-subtitle>Invia una notifica al responsabile del Ticket quando viene chiuso
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                            color="primary" 
                            hide-details
                            v-model="settings['notify_expiring_trouble']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scadenza Ticket</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando un Ticket sta per scadere
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>      

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_expiring_trouble']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field 
                                    label="Numero giorni prima"
                                    v-model="settings['notify_expiring_trouble_day_before']"
                                    type="number"
                                    outlined
                                    dense
                                    required
                                    :error-messages="errors.collect('daybefore1')"
                                    v-validate="'required'"
                                    data-vv-name="daybefore1"
                                    data-vv-as="Numero giorni prima"
                                ></v-text-field>   
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_expired_trouble']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Ticket Scaduto</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando un Ticket è scaduto
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox
                            color="primary"
                            hide-details
                            v-model="settings['notify_carnet_hours_low']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Ore Carnet in esaurimento</v-list-item-title>
                            <v-list-item-subtitle>Invia una notifica quando le ore residue di un contratto carnet scendono sotto una soglia percentuale
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_carnet_hours_low']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field
                                    label="Soglia percentuale (%)"
                                    v-model="settings['carnet_hours_low_threshold']"
                                    type="number"
                                    outlined
                                    dense
                                    required
                                    hint="Default: 20%"
                                    persistent-hint
                                    :error-messages="errors.collect('carnet_threshold')"
                                    v-validate="'required|min_value:1|max_value:100'"
                                    data-vv-name="carnet_threshold"
                                    data-vv-as="Soglia percentuale"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_expiring_contract']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scadenza Contratto</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando un contratto sta per scadere
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>     
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_expiring_contract']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field 
                                    label="Numero giorni prima"
                                    v-model="settings['notify_expiring_contract_day_before']"
                                    type="number"
                                    name="daybefore2"
                                    outlined
                                    dense
                                    required
                                    :error-messages="errors.collect('daybefore2')"
                                    v-validate="'required'"
                                    data-vv-name="daybefore2"
                                    data-vv-as="Numero giorni prima"
                                ></v-text-field>     
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['reminder_contract_maintenance_visit']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Reminder visita di manutenzione di un contratto</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando sta per arrivare il giorno della visita periodica di manutenzione in un contratto
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['reminder_contract_maintenance_visit']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field
                                    label="Numero giorni prima"
                                    v-model="settings['reminder_contract_maintenance_visit_day_before']"
                                    type="number"
                                    outlined
                                    dense
                                    required
                                    :error-messages="errors.collect('Numero giorni prima')"
                                    v-validate="'required'"
                                    :data-vv-name="'Numero giorni prima'"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>


                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['send_notifications_trouble_status']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Invia notifica al cambio di stato di un Ticket</v-list-item-title>
                            <v-list-item-subtitle>Invia una notifica a un utente amministratore delle chiamate al loro cambio di stato
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['send_notifications_trouble_status']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                                <v-slide-y-transition>
                                    <div>
                                        <v-row>
                                            <v-col class="px-2" cols="12" md="6" lg="5" >
                                                <v-select
                                                    name="Stati Ticket"
                                                    label="Stati Ticket"
                                                    :items="troubleStatus"
                                                    small-chips
                                                    dense
                                                    outlined
                                                    clearable
                                                    multiple
						                            :menu-props="{'offset-y': true}"
                                                    v-model="settings['send_notifications_trouble_status_selected']"
                                                    :error-messages="errors.collect('Stati ticket')"
                                                    v-validate="'required'"
                                                    :data-vv-name="'Stati ticket'"
                                                ></v-select>
                                            </v-col>
                                            <v-col class="px-4" cols="12" md="6" lg="5" >
                                                <v-combobox
                                                    name="Indirizzo mail"
                                                    label="Indirizzo mail"
                                                    small-chips
                                                    combobox
                                                    dense
                                                    outlined
                                                    clearable
                                                    multiple
                                                    v-model="settings['send_notifications_trouble_status_email']"
                                                    :error-messages="errors.collect('Indirizzo mail')"
                                                    v-validate="'email'"
                                                    :data-vv-name="'Indirizzo mail'"
                                                ></v-combobox>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-slide-y-transition>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>
                

                <v-subheader class="pl-4">Template Mail Stati</v-subheader>

                <v-list three-line subheader class="background-2 pa-2">
                    <v-list-item class="my-0" v-for="(gt, key, i) in generaltypes" :key="i">
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['template_mail_settings'][gt.value + '_checkbox']" @change="resetSelect($event, gt.value)"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ gt.text }}</v-list-item-title>
                            <v-list-item-subtitle>
                                <v-col cols="12" sm="12" md="8" lg="3" class="pl-0">
                                    <v-select
                                        :items="mailtemplates"
                                        :disabled="!settings['template_mail_settings'][gt.value + '_checkbox']"
                                        v-model="settings['template_mail_settings'][gt.value]"
                                        label="Template Mail"
                                        single-line
                                        no-data-text="Nessun template"
                                        dense
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        :menu-props="{'offset-y': true}"
                                    ></v-select>
                                </v-col>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox
                                color="primary"
                                hide-details
                                v-model="settings['disable_pdf_attachment_on_close']">
                            </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Disabilita allegato PDF alla chiusura</v-list-item-title>
                            <v-list-item-subtitle>Non allegare automaticamente il PDF del rapporto ticket alla mail di chiusura
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-subheader class="pl-4">Template Default Rapporti</v-subheader>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-file-document-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Template per invio rapporto intervento</v-list-item-title>
                            <v-list-item-subtitle>
                                <v-col cols="12" sm="12" md="8" lg="4" class="pl-0 pt-3">
                                    <v-select
                                        :items="mailtemplates"
                                        v-model="settings['default_template_intervention_report']"
                                        label="Template Mail"
                                        single-line
                                        no-data-text="Nessun template"
                                        dense
                                        clearable
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        :menu-props="{'offset-y': true}"
                                    ></v-select>
                                </v-col>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-file-document-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Template per invio rapporto chiusura</v-list-item-title>
                            <v-list-item-subtitle class="text-wrap">
                                Usato per l'invio manuale del rapporto quando nella mail automatica di chiusura è stata disattivata l'inclusione del PDF allegato
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <v-col cols="12" sm="12" md="8" lg="4" class="pl-0 pt-3">
                                    <v-select
                                        :items="mailtemplates"
                                        v-model="settings['default_template_close_report']"
                                        label="Template Mail"
                                        single-line
                                        no-data-text="Nessun template"
                                        dense
                                        clearable
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        :menu-props="{'offset-y': true}"
                                    ></v-select>
                                </v-col>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-subheader class="pl-4">Zone IVA</v-subheader>

                <v-row class="py-3 mx-0">
                    <v-col cols="6" style="margin: auto; padding-left: 16px;" class="body-2 pl-5">
                        IVA per clienti Nazionali
                    </v-col>
                    <v-col class="px-5" cols="6" ref="vatsetting">
                        <v-autocomplete
                            :items="vats"
                            label="IVA*"
                            v-model="settings['vat_vatzone']"
                            item-text="text"
                            item-value="value"
                            dense
                            :error-messages="errors.collect('IVA')"
                            v-validate="'required'"
                            data-vv-name='IVA'
                            data-vv-as="IVA"
                            outlined
                        ></v-autocomplete>
                    </v-col>
                </v-row>


                <v-subheader class="pl-4">Interventi e Prodotti</v-subheader>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['products_association_intervention']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Associazione Prodotti negli Interventi</v-list-item-title>
                            <v-list-item-subtitle>Permetti di aggiungere dei prodotti a un'intervento
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list two-line subheader class="background-2 pa-2" v-if="settings['products_association_intervention']">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                            color="primary" 
                            hide-details
                            v-model="settings['product_intervention_movements']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Movimentazioni Magazzino per prodotti inseriti negli interventi</v-list-item-title>
                            <v-list-item-subtitle>Rendi attive le movimentazioni di magazzino di scarico per i prodotti inseriti negli Interventi dei Ticket
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list two-line subheader class="background-2 pa-2" v-if="settings['products_association_intervention']">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox
                            color="primary"
                            hide-details
                            v-model="settings['show_product_cost']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Costo dei prodotti negli Interventi</v-list-item-title>
                            <v-list-item-subtitle>Mostra la colonna del costo d'acquisto nei prodotti degli interventi: il costo si congela sulla riga al momento dell'inserimento
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['enable_hourly_shots']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scatti orari</v-list-item-title>
                            <v-list-item-subtitle>Imposta degli scatti orari sulle durate degli interventi per calcolare tariffe non al minuto 
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>     
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['enable_hourly_shots']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field 
                                    label="Minuti scatto"
                                    v-model="settings['intervention_hourly_shots']"
                                    type="number"
                                    name="hourly_shots"
                                    outlined
                                    dense
                                    required
                                    :error-messages="errors.collect('hourly_shots')"
                                    v-validate="'required'"
                                    data-vv-name="hourly_shots"
                                    data-vv-as="Minuti scatto"
                                ></v-text-field>     
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-action>
                                <v-checkbox color="primary" v-model="settings['print_duration_rounded']"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Stampa Durata</v-list-item-title>
                                <v-list-item-subtitle>Mostra nella stampa la durata degli interventi conteggiata con gli scatti orari 
                            </v-list-item-subtitle>
                        </v-list-item-content>                            
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['enable_min_interventions_duration']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Durata minima intervento</v-list-item-title>
                            <v-list-item-subtitle>Imposta durata minima per ogni intervento da conteggiare
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>     
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['enable_min_interventions_duration']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field 
                                    label="Durata minima intervento"
                                    v-model="settings['min_interventions_duration']"
                                    type="number"
                                    name="min_interventions_duration"
                                    outlined
                                    dense
                                    required
                                    :error-messages="errors.collect('min_interventions_duration')"
                                    v-validate="'required'"
                                    data-vv-name="min_interventions_duration"
                                    data-vv-as="Durata minima intervento"
                                ></v-text-field>     
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-text-field
                                label="Codice prodotto per ore intervento"
                                v-model="settings['productcode_hours']"
                                outlined
                                dense
                            ></v-text-field>
                        </v-list-item-content>
                    </v-list-item>     
                </v-list>

                <v-subheader class="pl-4">Visualizzazione</v-subheader>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox
                                color="primary"
                                hide-details
                                v-model="settings['compact_trouble_view']"
                            ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Vista compatta Ticket</v-list-item-title>
                            <v-list-item-subtitle>Compatta tutti i pannelli secondari nella scheda Ticket, mantenendo espansa la sezione Interventi</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

    export default {
        name: 'tickets-options',
        mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'trouble',
                settings: {
                    'product_intervention_movements': false,
                    'show_product_cost': false,
                    'notify_owner_at_trouble_close': false,
                    'notify_expiring_trouble': false,
                    'notify_expired_trouble': false,
                    'trouble_expiring_day_before': null,
                    'notify_expiring_contract': false,
                    'contract_expiring_day_before': null,
                    'reminder_contract_maintenance_visit': false,
                    'reminder_contract_maintenance_visit_day_before': null,
                    'send_notifications_trouble_status': false,
                    'send_notifications_trouble_status_selected': [],
                    'template_mail_settings': {},
                    'disable_pdf_attachment_on_close': false,
                    'default_template_intervention_report': null,
                    'default_template_close_report': null,
                    'vat_vatzone': null,
                    'products_association_intervention': false,
                    'enable_hourly_shots': false,
                    'intervention_hourly_shots': null,
                    'print_duration_rounded': false,
                    'compact_trouble_view': false,
                    'notify_carnet_hours_low': false,
                    'carnet_hours_low_threshold': null,
                },
                troubleStatus: [],
                vats: [],
                generaltypes: {},
                mailtemplates: [],
            }
        },

        watch: {
            settings: {
                handler() {
                    if(!this.settings['notify_expiring_trouble']) {
                        Vue.set(this.settings, 'trouble_expiring_day_before', null)
                    }
                    if(!this.settings['notify_carnet_hours_low']) {
                        Vue.set(this.settings, 'carnet_hours_low_threshold', null)
                    }
                    if(!this.settings['enable_hourly_shots']) {
                        Vue.set(this.settings, 'intervention_hourly_shots', null)
                        Vue.set(this.settings, 'print_duration_rounded', false)
                    }
                },
                deep: true,
            }
        },

        methods: {
			resetSelect($event, key) {
				if(!$event) {
					Vue.set(this.settings['template_mail_settings'], key, null)
				}
			},
        },


        created() {
            this.axios.get('settings/'+this.model).then(response => {

                _.forEach(response.data.settings, (setting) => {
                    Vue.set(this.settings, setting.key, setting.value)
                })

                this.axios.post('generaltype/', {key: 'trouble_status'}).then(response => {
                    this.troubleStatus = response.data.general_type
                    this.generaltypes = response.data.general_type
                    _.forEach(this.generaltypes, (gt) => {
                        Vue.set(this.settings['template_mail_settings'], gt.value + '_checkbox', false)
                    })

                    this.axios.post('templates-trouble-filters').then(response => {
                        this.mailtemplates = response.data.data.data
                    }, response => {
                        // error callback
                    });	

                    this.axios.get('settings/trouble/template_mail_settings/').then(response => {
                        if(response.data.settings[0] && response.data.settings[0].value.length === 0) {
                            delete response.data.settings[0].value
                        } 
                        this.settings.template_mail_settings = typeof response.data.settings[0].value !== 'undefined' ? response.data.settings[0].value : {}
                    }, response => {
                        // error callback
                    });

                    this.$store.commit('endProgress')

                }, response => {
                // error callback
                })

                this.axios.post('generaltype/', {key: 'vat'}).then(response => {
                    this.vats = response.data.general_type

                    this.$store.commit('endProgress')

                }, response => {
                // error callback
                })
            

            }, response => {
                // error callback
            })
        }

    }
</script>

<style scoped>

</style>